import { LTileColorFilter } from "./tileColorFilter";
import { withLeaflet, GridLayer } from "react-leaflet";
import { GridLayer as LGridLayer, Bounds } from "leaflet";
import _ from "lodash";
import PropTypes from "prop-types";

class LAwesomeTileLayer extends LTileColorFilter {
  constructor(url, options) {
    if (_.isNil(options.useEdgeBuffer)) {
      options.useEdgeBuffer = false;
    }
    if (_.isNil(options.edgeBufferTiles)) {
      options.edgeBufferTiles = 1;
    }

    super(url, options);
  }

  initialize(url, options) {
    if (_.isNil(options.useEdgeBuffer)) {
      options.useEdgeBuffer = false;
    }
    if (_.isNil(options.edgeBufferTiles)) {
      options.edgeBufferTiles = 1;
    }
    super.initialize(url, options);
  }

  // override GridLayer class's private method which gets the pixel bounds
  // this way we can add a buffer: the map will pre load n number of tiles from the edge of the viewport.
  // the number of pre loaded tiles are set by options.edgeBufferTiles
  // noinspection JSUnusedGlobalSymbols
  _getTiledPixelBounds(center) {
    let pixelBounds = LGridLayer.prototype._getTiledPixelBounds.call(
      this,
      center
    );
    if (!this.options.useEdgeBuffer) {
      return pixelBounds;
    }
    const edgeBufferTiles = this.options.edgeBufferTiles;

    if (edgeBufferTiles > 0) {
      const pixelEdgeBuffer = super.getTileSize().multiplyBy(edgeBufferTiles);
      pixelBounds = new Bounds(
        pixelBounds.min.subtract(pixelEdgeBuffer),
        pixelBounds.max.add(pixelEdgeBuffer)
      );
    }

    return pixelBounds;
  }
}

class AwesomeTileLayer extends GridLayer {
  static propTypes = {
    filter: PropTypes.arrayOf(PropTypes.string),
    useEdgeBuffer: PropTypes.bool,
    edgeBufferTiles: PropTypes.number
  };

  // noinspection JSUnusedGlobalSymbols
  createLeafletElement(props) {
    return new LAwesomeTileLayer(props.url, super.getOptions(props));
  }
}

export default withLeaflet(AwesomeTileLayer);
